// @flow
import React from 'react';
import { components } from '@peachjar/components';
import Radio from './Radio';

const { TextInput } = components;

type Props = {
  handleFlyerDisclaimerRequiredRadioSelectionYes: () => void,
  handleFlyerDisclaimerRequiredRadioSelectionNo: () => void,
  handleFlyerDisclaimer: () => void,
  flyerDisclaimerRequired: boolean,
  flyerDisclaimer: string,
};

const OrganizationFlyerDisclaimer = ({
  handleFlyerDisclaimerRequiredRadioSelectionYes,
  handleFlyerDisclaimerRequiredRadioSelectionNo,
  flyerDisclaimerRequired,
  handleFlyerDisclaimer,
  flyerDisclaimer,
}: Props) => (
  <div className="d-flex flex-column">
    <div className="d-flex">
      <div>
        <p>
          Does your district require a disclaimer to appear on all flyers from
          community organizations?
        </p>
      </div>
      <div className="pl-4 pt-0">
        Yes<Radio
          id="yes"
          color="jungle"
          onClick={handleFlyerDisclaimerRequiredRadioSelectionYes}
          checked={flyerDisclaimerRequired}
        />
        No<Radio
          id="no"
          color="jungle"
          onClick={handleFlyerDisclaimerRequiredRadioSelectionNo}
          checked={!flyerDisclaimerRequired}
        />
      </div>
    </div>
    {flyerDisclaimerRequired && (
      <div className="pr-5">
        <TextInput
          id="disclaimerInput"
          multiline
          fullWidth
          value={flyerDisclaimer}
          onChange={handleFlyerDisclaimer}
          label="Flyer Disclaimer"
          data-testid="organizationFlyerDisclaimerTextInput"
        />
        <p className="pt-2" style={{ color: '#707070' }}>
          E.g. This program is not sponsored by Your District Name. Approval to
          distribute flyers is a community service and does not imply
          endorsement.
        </p>
      </div>
    )}
  </div>
);

export default OrganizationFlyerDisclaimer;



// WEBPACK FOOTER //
// ./src/Onboarding/Setup/organization/components/OrganizationFlyerDisclaimer.jsx